import { Injectable } from '@angular/core';
import { defer, Observable } from 'rxjs';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { map } from 'rxjs/operators';

export interface AssignToMePayload {
  accountId: string,
}

@Injectable({
  providedIn: 'root',
})
export class AssignToMeService {
  constructor(private functions: Functions) {
  }

  create(payload: AssignToMePayload): Observable<any> {
    return defer(() =>
      httpsCallable<AssignToMePayload, any>(this.functions, 'assignToMe')(payload)
    ).pipe(
      map(response => response.data),
    );
  }
}
